import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css'],
})
export class ModalComponent {
    @Input() modalId!: string;
    @Input() modalTitle!: string;
    @Input() buttonConfirmText!: string;
    @Input() buttonCancelText!: string;
    @Input() closeOnConfirm: boolean = true;
    @Input() confirmLoading = false;          // show spinner + disable confirm
    @Input() disableConfirm = false;          // optional extra guard to disable confirm button

    @Output() modalEventConfirm = new EventEmitter<string>();
    @Output() modalEventCancel = new EventEmitter<void>();

    private lastFocusedEl: HTMLElement | null = null;

    constructor(private modalService: ModalService) { }

    // Call this right before opening the modal (see note below)
    rememberFocus() {
        this.lastFocusedEl = document.activeElement as HTMLElement | null;
    }

    private blurActiveElement() {
        (document.activeElement as HTMLElement | null)?.blur();
    }

    private restoreFocus() {
        setTimeout(() => this.lastFocusedEl?.focus(), 0);
    }

    modalConfirmEvent(id: string) {
        // prevent multiple clicks while loading / disabled
        if (this.confirmLoading || this.disableConfirm) return;

        this.blurActiveElement();

        // emit first (important for async confirm flows like PIN verify)
        this.modalEventConfirm.emit(id);

        // only auto-close when explicitly allowed
        if (this.closeOnConfirm) {
            this.modalService.close(id);
        }

        this.restoreFocus();
    }

    modalCancelEvent(id: string) {
        this.blurActiveElement();
        this.modalService.close(id);
        this.modalEventCancel.emit();
        this.restoreFocus();
    }
}
